import { createSSRApp } from 'vue';
import App from './App.vue';
import 'uno.css';
import '@/styles/index.scss';
import '@/styles/common.scss';
import '@/static/fonts/iconfont.css'
import { useUserStoreHook } from '@/stores/modules/userStore';

import { setupStore } from '@/stores';
import CustomerService from '@/components/CustomerService.vue';
export function createApp() {
    const app = createSSRApp(App);
    app.config.globalProperties.$test = () => {
        console.log('test----------------');
    };
    app.component('customer-service', CustomerService);

    setupStore(app);
    // console.log(process.env.NODE_ENV )
    const userStore = useUserStoreHook();
    const token = uni.getStorageSync('token');
    if (token) {
        userStore.reqSiteInfo();
        userStore.reqUserInfo();
    }
    userStore.reqConfigInfo();
    // //每间隔 1 分钟请求一次活跃度
    // setInterval(() => {
    //     userStore.reqActiveDegree();
    // }, 60000);
    return {
        app
    };
}
